import { Button } from '@mui/material';
import PersonAddIcon from '@mui/icons-material/PersonAdd';

export default function NextPatientButton({ onClick }) {
  return (
    <Button
      variant="contained"
      sx={{
        backgroundColor: "#B4B4B4",
        color: "#005F46",
        textTransform: "none",
        fontSize: "16px",
        fontWeight: "bold",
        padding: "8px 16px",
        borderRadius: "8px",
        display: "flex",
        alignItems: "center",
        gap: "8px",
        "&:hover": {
          backgroundColor: "#D6D6D6",
        },
      }}
      onClick={onClick}
    >
      Next patient
      <PersonAddIcon sx={{ color: "#005F46" }} />
    </Button>
  );
}
